module.exports = __webpack_public_path__ + "img/cvv_card.22794c50.png";